import $ from 'jquery';

export default class ListLoadMore {
  constructor(el) {
    this.$list = $(el);
    this.$loading = $(
      '<div class="loader animate__loader mt-3 d-none"><i class="ri-loader-4-fill"></i></div>',
    );
    this._state = {
      loading: false,
      noMore: false,
    };
    this.init();
  }
  init() {
    const { $list, $loading, _state } = this;
    const list = $list[0];
    if (list._listLoadMoreInit) return;
    list._listLoadMoreInit = true;
    $list.after($loading);
    $list.position_callback({
      offsetBottom: window.innerHeight,
      bottomUp() {
        if (!_state.loading && !_state.noMore) $list.trigger('reachBottom');
      },
    });
  }
  loading(t = true) {
    const { $loading, _state } = this;
    _state.loading = t;
    t ? $loading.removeClass('d-none') : $loading.addClass('d-none');
  }
  insertHTML(html) {
    this.loading(false);
    const { $list } = this;
    $list.append($(html));
  }
  noMore(text) {
    const { $loading } = this;
    this._state.noMore = true;
    $loading.after($(`<div class="text-muted text-center typography--caption mt-3">${text}</div>`));
  }
}
